import type { Price } from '@backmarket/http-api'
import type { GetPickersResponse } from '@backmarket/http-api/src/api-specs-navigation-experience/product/pickers'
import type { PaymentMethod } from '@backmarket/http-api/src/api-specs-payment/payment/payment.types'

/**
 * Filter a list of payment methods by removing those disabled for AB testing (remove Klarna or Affirm)
 */
export function filterABTestedPaymentMethods(
  experiments: Record<string, string>,
  paymentMethods: PaymentMethod[],
  _bagPrice: Price | null,
) {
  const filter = (methods: PaymentMethod[], experimentVariation: string) => {
    switch (experimentVariation) {
      case 'withoutScalapay':
        return methods.filter((method) => method.group !== 'scalapay')
      default:
        return methods
    }
  }

  let filtered = paymentMethods
  filtered = filter(filtered, experiments['experiment.enableScalapayIT'])

  return filtered
}

/**
 * remove payement methods that are disabled for AB testing.
 */
export function filterSelectedOfferABTestedPaymentMethods(
  experiments: Record<string, string>,
  selectedOffer: NonNullable<GetPickersResponse['selectedOffer']>,
) {
  if (!selectedOffer.paymentMethods) {
    return selectedOffer
  }

  return {
    ...selectedOffer,
    paymentMethods: filterABTestedPaymentMethods(
      experiments,
      selectedOffer.paymentMethods,
      null,
    ),
  }
}
